import { isFramed } from "@/lib/framed";

export const PREVIEW_READY = "landing-preview-ready";
export const PREVIEW_CONTENT = "landing-preview-content";

export function isLandingPreview(win: Window = window): boolean {
  try {
    return new URLSearchParams(win.location.search).get("lp_preview") === "1" && win.parent !== win && isFramed(win);
  } catch {
    return false;
  }
}

/** Returns the raw preview content, or undefined when the message must be ignored. */
export function readPreviewMessage(
  event: Pick<MessageEvent, "origin" | "source" | "data">,
  slug: string,
  win: Window = window,
): unknown {
  if (event.origin !== win.location.origin || event.source !== win.parent) return undefined;
  const data = event.data as { type?: unknown; slug?: unknown; content?: unknown } | null;
  if (!data || typeof data !== "object" || data.type !== PREVIEW_CONTENT || data.slug !== slug) return undefined;
  return data.content ?? null;
}
